import { render, staticRenderFns } from "./cp-student-details.vue?vue&type=template&id=2b322831&scoped=true"
import script from "./cp-student-details.ts?vue&type=script&lang=ts&external"
export * from "./cp-student-details.ts?vue&type=script&lang=ts&external"
import style0 from "./cp-student-details.scss?vue&type=style&index=0&id=2b322831&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b322831",
  null
  
)

export default component.exports